
angular.module('bmsApp.marketing').factory('DiscountCodeSvc', function (CRUDSvc, DISCOUNT_CODE_API) {

	return {
		index: function () {
			return CRUDSvc.get(DISCOUNT_CODE_API.INDEX);
		}
	};

}).constant('DISCOUNT_CODE_API', {
	INDEX: 'api/discountCode/index'
});
